import type { ChainNetwork } from '@ducat-unit/core';
import { memoize } from 'lodash';

import { getConfig } from '@/config/config';
import type { NetworkSettingsConfig } from '@/config/config.types';

import type { UserNetworkSettings } from './useAppStore';

export const deriveConfig = memoize(
  (selectedNetwork: ChainNetwork, userNetworkSettings: UserNetworkSettings | undefined) => {
    const config = getConfig(selectedNetwork);
    if (!config) {
      return;
    }
    const userGuardianUrl = userNetworkSettings?.guardianUrl;
    const guardianUrl =
      userGuardianUrl && config.guardians.some((guard) => guard.guardianUrl === userGuardianUrl) ? userGuardianUrl : config.guardianUrl;

    const override = {
      // validate if guardianUrl value in userNetworkSettings exists in config.guardians:
      guardianUrl,
      ...(userGuardianUrl === guardianUrl && userNetworkSettings?.guardMemberPubkey
        ? { guardMemberPubkey: userNetworkSettings.guardMemberPubkey }
        : {}),
      ...(userNetworkSettings?.customGuardianUrl ? { customGuardianUrl: userNetworkSettings.customGuardianUrl } : {}),
      ...(userNetworkSettings?.customGuardianPubkey ? { customGuardianPubkey: userNetworkSettings.customGuardianPubkey } : {}),
    };
    // console.log(`[useConfig]`, { userGuardianUrl });

    return {
      ...config,
      ...override,
    } as NetworkSettingsConfig;
  },
  (selectedNetwork, userNetworkSettings) => `${selectedNetwork}-${JSON.stringify(userNetworkSettings)}`,
);
